<div id="banner-dialog">
  <ng-container *ngIf="currentIdentifier === 'morbus-fabry-banner'">
    <a href="https://www.rarediseasesacademy.de/?utm_source=Website&utm_medium=fabry-wissen_de&utm_campaign=Website_Fabry" target="_blank"><img src="/assets/img/template/banner.jpg"></a>
  </ng-container>
  <!--<a href="https://www.rarediseasesacademy.de/?utm_source=Website&utm_medium=fabry-wissen_de&utm_campaign=Website_Fabry" target="_blank"><img src="/assets/img/template/banner.jpg"></a>-->
</div>